import React, { PureComponent, Fragment } from "react"
import PropTypes from "prop-types"
import { graphql } from "react-apollo"
import { compose } from "recompose"
import { connect } from "react-redux"
import { formValueSelector } from "redux-form"
import { isEmpty, isNil, uniqBy, take, once, reject, contains } from "ramda"
import qs from "query-string"
import random from "lodash.random"
import styled from "styled-components"
import RatesActions from "./rates.redux"
import UIActions from "../../redux/ui.redux"
import { SEARCH_QUERY } from "./rates.queries"

import Box from "../../lib/ui/ui-box"
import RatesAside from "../../components/rates-aside"
import RatesQuotes from "../../components/rates-quotes"
import LoadingSpinner from "../../components/loading-spinner"
import DramaticLoader from "../../components/dramatic-loader"
import MenuToggle from "../../components/mobile-menu-toggle"
import MobileMenuWrapper from "../../components/mobile-menu-manager/mobile-menu-wrapper.component"
import PreventScroll from "../../components/prevent-scroll"
import generateInternalRate from "../../utils/generate-internal-rate"
import WithSizes from "../../hocs/with-sizes.hoc"

const rand = random(1500, 2000)

const TranslatedMobileMenuWrapper = styled(MobileMenuWrapper)`
  top: ${props => (props.isRateMenuToggled ? "0" : "100%")};
  transform: ${props =>
    props.isRateMenuToggled ? "translateY(100%)" : "translateY(0%)"};
  transition: all 0.3s ease-in-out;
`

class Container extends PureComponent {
  static propTypes = {
    isMobile: PropTypes.bool,
    isDesktopAndGreater: PropTypes.bool
  }
  state = {
    firstLoad: true
  }

  componentDidMount() {
    window.analytics.track("Viewed Rates")
  }

  componentDidUpdate(prevProps) {
    if (this.state.firstLoad === true) {
      if (this.props.loading === false) {
        setTimeout(() => {
          this.setState({
            firstLoad: false
          })
        }, rand)
      }
    }
  }

  render() {
    const {
      products,
      loading,
      isDesktopAndGreater,
      isRateMenuToggled
    } = this.props
    if (this.state.firstLoad) return <DramaticLoader />
    return (
      <Box flexDirection="column" bg="white">
        {isDesktopAndGreater && <RatesAside {...this.props} />}
        {!isDesktopAndGreater && <MenuToggle onClick={this.props.toggleMenu} />}
        <Box
          flexDirection="column"
          pl={["0", "0", "265px"]}
          ml={[4, 4, 10]}
          mr={[4, 4, 4, 14]}
          pt={[2]}
          pb={[2]}
          bg="backgroundPrimary"
        >
          {loading || isEmpty(products) || isNil(products) ? (
            <Box style={{ height: "100vh" }} align="center" justify="center">
              <LoadingSpinner />
            </Box>
          ) : (
            <RatesQuotes {...this.props} />
          )}
        </Box>
        {!isDesktopAndGreater && (
          <TranslatedMobileMenuWrapper isRateMenuToggled={isRateMenuToggled}>
            <Fragment>
              <PreventScroll />
              <RatesAside {...this.props} />
            </Fragment>
          </TranslatedMobileMenuWrapper>
        )}
      </Box>
    )
  }
}

const selector = formValueSelector("ratesQueryForm")
const mapStateToProps = (state, { location }) => {
  const query = state.rates.query

  const { cfPropertyValue, cfMortgageType, cfLoanAmount } = qs.parse(
    location.search
  )

  const selectedRate = selector(state, "selectedRate")
  const selectedTerm = selector(state, "selectedTerm")
  return {
    query,
    bankAverageRate: generateInternalRate(selectedRate, selectedTerm),
    propertyValue: selector(state, "propertyValue"),
    downpaymentAmount: selector(state, "downpaymentAmount"),
    cfPropertyValue,
    cfMortgageType,
    cfLoanAmount,
    isRateMenuToggled: state.ui.isRateMenuToggled
  }
}

const mapDispatchToProps = dispatch => ({
  updateRatesQuery: query => dispatch(RatesActions.updateRatesQuery(query)),
  toggleMenu: () => dispatch(UIActions.toggleRateMenu())
})

const trackUniqProductsOnce = once(({ sampleSize, uniqueCount }) => {
  window.analytics.track("System:Unique Products Per Sample", {
    sampleSize,
    uniqueCount
  })
})

const mapResultsToProps = ({ data }) => {
  const lenderName = ({ lender }) => lender.name
  const sample = data.products ? data.products : []
  const shouldExclude = x => contains(x.id, ["7831", "7833"])
  const withoutExcludedProducts = reject(shouldExclude, sample)
  const takeFive = take(5)
  const uniqued = uniqBy(lenderName, withoutExcludedProducts)
  const uniqProducts = takeFive(uniqued)
  if (!data.loading) {
    trackUniqProductsOnce({
      sampleSize: data.products.length,
      uniqueCount: uniqued.length
    })
  }
  return {
    products: uniqProducts,
    loading: data.loading
  }
}

const mapPropsToOptions = props => {
  return {
    variables: {
      where: props.query.WHERE
    }
  }
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  graphql(SEARCH_QUERY, {
    props: mapResultsToProps,
    options: mapPropsToOptions
  }),
  WithSizes
)(Container)



// WEBPACK FOOTER //
// ./src/containers/rates/rates.container.js